module.exports = __webpack_public_path__ + "static/home_bodegon-1a5f9905f0ed1140017ed73f3b0f488b.png";